import { useMutation, useQuery } from "react-query"

import {
  createContactPaymentTxn,
  getPayableContactInvoices,
  getPaymentPreview,
} from "src/api/Billing/Payments"

export const payableContactInvoicesKey = ({ marinaSlug, contactId }) => [
  "payableContactInvoices",
  marinaSlug,
  contactId,
]

export const usePayableContactInvoices = ({
  marinaSlug,
  contactId,
  enabled = true,
}) =>
  useQuery(
    payableContactInvoicesKey({ marinaSlug, contactId }),
    () => getPayableContactInvoices({ marinaSlug, contactId }),
    { enabled, refetchOnWindowFocus: false }
  )

export const paymentPreviewKey = ({
  contactId,
  invoiceIds,
  paymentMethodId,
  cardPresent,
}) => ["paymentPreview", contactId, invoiceIds, paymentMethodId, cardPresent]

export const usePaymentPreview = ({
  marinaSlug,
  contactId,
  invoiceIds,
  paymentMethodId = null,
  cardPresent = false,
}) =>
  useQuery(
    paymentPreviewKey({ contactId, invoiceIds, paymentMethodId, cardPresent }),
    () =>
      getPaymentPreview({
        marinaSlug,
        contactId,
        invoiceIds,
        paymentMethodId: paymentMethodId ?? undefined,
        cardPresent,
      }),
    { keepPreviousData: true, refetchOnWindowFocus: false, retry: false }
  )

export const useCreateContactPayment = ({ marinaSlug, contactId, onError }) =>
  useMutation(
    (data) => createContactPaymentTxn({ marinaSlug, contactId, data }),
    { onError }
  )
